// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cd5e5326","239":"8f9b1273","453":"deea031d","732":"7276bf39"}[chunkId] + ".chunk.js";
};